import type { ReactNode } from "react";

import styles from "./styles.module.css";

interface AtlasPanelProps {
  kicker?: string;
  title: string;
  children: ReactNode;
  variant?: "dark" | "light";
}

export function AtlasPanel({ kicker, title, children, variant = "dark" }: AtlasPanelProps) {
  return (
    <article className={`${styles.panel} ${styles[variant]}`} data-reveal>
      {kicker ? <span className={styles.kicker}>{kicker}</span> : null}
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.body}>{children}</div>
      <div className={styles.mapGrid} aria-hidden="true" />
    </article>
  );
}

export default AtlasPanel;
